import { CompanyDetailsApiResponse } from '../service/models/companyDetails'

/**
 * Finds a company by ID with case-insensitive matching. Handles API/cookie case inconsistencies by comparing lowercase IDs.
 *
 * @param companies - Array of companies to search
 * @param companyId - Company ID to find (case-insensitive)
 * @returns Matching company or null if not found
 */
export function findCompanyById(
	companies: CompanyDetailsApiResponse[],
	companyId: string | null | undefined
): CompanyDetailsApiResponse | null {
	if (!companyId || companies.length === 0) {
		return null
	}

	return (
		companies.find(
			c => c.companyId?.toLowerCase() === companyId.toLowerCase()
		) ?? null
	)
}
